// BASE LIBRAIRIES
import './init_Jquery';
import 'jquery-ui/dist/jquery-ui.min';
import * as bootstrap from 'bootstrap';
import Rails from '@rails/ujs';

window.bootstrap = bootstrap;

// EXTERNAL DEPENDENCIES
import 'intl-tel-input/build/js/intlTelInput-jquery.min';
import toastr from 'toastr';
import 'slick-carousel/slick/slick.min';

// CAPSENS HELPERS
import './channels/cable';
import './helpers';

// PLATFORM JS CODE
import './address_autocomplete';
import './carousel_project_subscription';
import './hide_show_password';
import './input_files';
import './mobile_profile_nav';
import './project_pictures_carousel';
import './projects_filters';
import './select';
import './select2_init';
import './subscription_expiration';
import './subscribe_modal';
import './projects/anchor_nav_pills';
import './users/affiliate_code';
import './users/profile';
import './popup_message';
//
// STIMULUS
import './controllers';

Rails.start();

window.toastr = toastr;

$(document).ready(function () {
  $('.auto-input').on('change', function () {
    var form = $(this).parents('form')[0];

    Rails.fire(form, 'submit');
  });

  Helpers.initTooltips();

  $('body').on('change', '.file-input', function () {
    if ($(this)[0].files[0] !== undefined) {
      $(this).parent().find('.label-wording').html($(this)[0].files[0].name);
    }
  });
});
